import React from 'react';
import { X as CloseIcon } from 'lucide-react';
import FullscreenToggleButton from '../../common/FullscreenToggleButton';
import PresenterCommentsButton from './PresenterCommentsButton';

function PresenterHeader({
  title,
  viewId,
  commentsOpen,
  isFullscreen,
  onToggleFullscreen,
  onToggleComments,
  onCommentsButtonMouseEnter,
  onClose,
}) {
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 border-b border-gray-200 shrink-0">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-gray-900 truncate">{title}</div>
        <div className="text-xs text-gray-500 truncate">{viewId}</div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <PresenterCommentsButton
          isActive={commentsOpen}
          onClick={onToggleComments}
          onMouseEnter={onCommentsButtonMouseEnter}
        />
        <FullscreenToggleButton
          isFullscreen={isFullscreen}
          onClick={onToggleFullscreen}
        />
        <button
          type="button"
          onClick={onClose}
          className="inline-flex shrink-0 items-center justify-center rounded-full h-9 w-9 border border-gray-200 bg-white hover:bg-gray-100 text-gray-600 hover:text-gray-900 shadow-sm"
          aria-label="Close presenter view"
        >
          <CloseIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}

export default PresenterHeader;
